<template>
  <div v-loading="loading">
    <el-card>
      <div class="title">
        <p>{{ $route.query.title }}</p>
        <div class="button">
          <el-button type="primary" @click="submitForm(20)" :disabled="loading"
            >提交</el-button
          >
          <el-button @click="backPage()" :disabled="loading">返回</el-button>
        </div>
      </div>
    </el-card>

    <el-card style="margin-top: 20px">
      <div class="info">
        <crud-title title="关联办单信息"></crud-title>
        <div class="order-info-title">
          <p class="tip">关联月度计划信息</p>
          <el-input
            v-model="orderNo"
            disabled
            maxlength="30"
            placeholder="请选择"
            class="input"
          ></el-input>
          <el-button
            :disabled="buttonDisabled"
            v-if="!disabled"
            type="primary"
            icon="el-icon-search"
            @click="openDialogInfo"
          ></el-button>
        </div>
        <FormTable
          ref="formTable"
          :formData="formData"
          :optionConfig="optionConfig"
        />
      </div>
    </el-card>

    <el-card style="margin-top: 20px">
      <avue-form ref="form" :option="formOption" v-model="ruleForm"></avue-form>
    </el-card>
    <div style="height: 100px"></div>
    <get-dialog-info
      ref="getDialogInfo"
      title="选择月度计划"
      v-if="dialogShow"
      :max="0"
      :apiConfig="apiConfig"
      :column="option.column"
      @getData="getData"
    ></get-dialog-info>
  </div>
</template>

<script>
import getDialogInfo from "@/components/GetDialogInfo/index";
import { getInfo, submit, getMonthList } from "../api";
import crudTitle from "@/components/CrudTitle/index";
import { searchTimeConfig } from "@/basic-common/util/common";

export default {
  name: "openTopBoxOrderCarLoading",
  components: {
    getDialogInfo,
    crudTitle,
  },
  data() {
    return {
      dialogShow: false,
      apiConfig: { getList: getMonthList },
      loading: false,
      formData: { list: [] },
      // 子表配置（使用 FormTable 展示与编辑选中的计划明细）
      optionConfig: {
        columnType: "edit",
        addBtn: false,
        column: [
          {
            label: "货主",
            prop: "custNo",
            type: "select",
            dicUrl: "/api/produce/blade-dept/select/distinct/select",
            props: { label: "deptName", value: "id" },
            disabled: true,
          },
          {
            label: "合同名称",
            prop: "contractName",
            type: "input",
            disabled: true,
          },
          {
            label: "物资名称",
            prop: "cargoName",
            type: "input",
            disabled: true,
          },
          {
            label: "数量(吨)",
            prop: "planTotalWeight",
            type: "custom-input",
            precision: 2,
            disabled: true,
          },
          {
            label: "发站",
            prop: "beginStation",
            type: "input",
            disabled: true,
          },
          {
            label: "到站",
            prop: "endStation",
            type: "input",
            disabled: true,
          },
          {
            label: "计划开始时间",
            prop: "intervalStartTime",
            type: "date",
            dateType: "datetime",
            disabled: true,
          },
          {
            label: "计划结束时间",
            prop: "intervalEndTime",
            type: "date",
            dateType: "datetime",
            disabled: true,
          },
          {
            label: "合同开始时间",
            prop: "contractStartTime",
            type: "date",
            dateType: "datetime",
            disabled: true,
          },
          {
            label: "合同结束时间",
            prop: "contractEndTime",
            type: "date",
            dateType: "datetime",
            disabled: true,
          },
          {
            label: "车厢数",
            prop: "carriageTotal",
            type: "custom-input",
            precision: 0,
            required: true,
          },
          {
            label: "集装箱数",
            prop: "containerTotal",
            type: "custom-input",
            precision: 0,
            required: true,
          },
        ],
      },
      formOption: {
        disabled: false,
        labelWidth: "115",
        menuPosition: "right",
        emptyBtn: false,
        submitBtn: false,
        ...this.$store.state.formOption,
        group: [
          {
            label: "装车办单",
            arrow: false,
            prop: "name0",
            column: [
              {
                label: "物资名称",
                prop: "cargoName",
                type: "select",
                remote: true,
                dicUrl:
                  "/api/produce/vardict/select/distinct/pycode?cargoName={{key}}",
                props: {
                  label: "varName",
                  value: "varNo",
                },
              },
              {
                label: "库区",
                prop: "stockCode",
                type: "select",
                remote: true,
                dataType: "number",
                dicUrl:
                  "/api/produce/location/select/distinct/pycode?stockName={{key}}",
                props: {
                  label: "locationName",
                  value: "locationCode",
                },
              },
              {
                label: "合同名称",
                prop: "contractName",
                type: "select",
                remote: true,
                dicUrl:
                  "/api/produce/transport-contract/select/distinct/pycode?contractName={{key}}",
                props: {
                  label: "contractName",
                  value: "id",
                },
              },
              {
                label: "剩余容量",
                prop: "stockRemain",
                type: "number",
                precision: 0,
                min: 1,
                max: 99999,
              },
              {
                label: "货主",
                prop: "custNo",
                type: "select",
                dicUrl: "/api/produce/blade-dept/select/distinct/select",
                props: {
                  label: "deptName",
                  value: "id",
                },
              },
              {
                label: "车次",
                prop: "trainNumber",
              },
            ],
          },
        ],
      },
      ruleForm: {},

      option: {
        ...this.$store.state.publicOption,
        disabled: false,
        addBtn: false,
        addRowBtn: false,
        cellBtn: false,
        editBtn: false,
        selection: false,
        viewBtn: false,
        delBtn: false,
        header: false,
        showSummary: true,
        menuWidth: 100,
        searchShow: false,
        height: 200,
        column: [
          {
            label: "货主",
            prop: "custNo",
            type: "select",
            dicUrl: "/api/produce/blade-dept/select/distinct/select",
            search: true, // 查询是否显示
            props: {
              label: "deptName",
              value: "id",
            },
          },
          {
            label: "合同名称",
            prop: "contractName",
            search: true, // 查询是否显示
            minWidth: 120,
            overHidden: true, // 表格超出隐藏
            type: "select",
            remote: true,
            dicUrl:
              "/api/produce/transport-contract/select/distinct/pycode?contractName={{key}}",
            props: {
              label: "contractName",
              value: "id",
            },
          },
          {
            label: "物资名称",
            prop: "cargoNo",
            search: true, // 查询是否显示
            minWidth: 120,
            overHidden: true, // 表格超出隐藏
            type: "select",
            remote: true,
            dicUrl:
              "/api/produce/vardict/select/distinct/pycode?cargoName={{key}}",
            props: {
              label: "varName",
              value: "varNo",
            },
          },
          {
            label: "数量(吨)",
            prop: "planTotalWeight",
            type: "number",
            precision: 2,
            min: 0.01,
            max: 99999,
            minWidth: 120,
            overHidden: true, // 表格超出隐藏
          },
          {
            label: "发站",
            prop: "beginStation",
            minWidth: 120,
            overHidden: true, // 表格超出隐藏
          },
          {
            label: "到站",
            prop: "endStation",
            minWidth: 120,
            overHidden: true, // 表格超出隐藏
          },
          {
            label: "计划开始时间",
            prop: "intervalStartTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            minWidth: 120,
            overHidden: true, // 表格超出隐藏
          },
          {
            label: "计划结束时间",
            prop: "intervalEndTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            minWidth: 120,
            overHidden: true, // 表格超出隐藏
          },
          {
            label: "合同开始时间",
            prop: "contractStartTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            minWidth: 120,
            overHidden: true, // 表格超出隐藏
          },
          {
            label: "合同结束时间",
            prop: "contractEndTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            minWidth: 120,
            overHidden: true, // 表格超出隐藏
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
          },
        ],
      },
      orderNo: "",
    };
  },
  created() {
    console.log(this);
    this.$router.$avueRouter.setTitle(this.$route.query.title);

    // if (!this.isNull(this.$route.query.id)) {
    //     this.getInfo()
    // }
  },
  methods: {
    // 查看详情
    getInfo() {
      getInfo(this.$route.query.id).then((res) => {
        this.ruleForm = res.data;
        if (this.$route.query.title == "入库信息详情") {
          this.formOption.disabled = true;
          this.option.disabled = true;
        }
      });
    },
    // 提交
    submitForm(isSubmit) {
      if (!this.formData.list || this.formData.list.length == 0) {
        this.$message.warning(`请选择月度计划信息！`);
        return;
      }
      // 子表无需单独校验，统一使用主表校验
      this.$refs.form.validate((valid, done, msg) => {
        if (valid) {
          this.loading = true;
          const list = this.formData.list.map((res) => ({
            prepareOrderId: res.myId,
            carriageTotal: res.carriageTotal,
            containerTotal: res.containerTotal,
          }));
          if (isSubmit == 20) {
            submit({ ...this.ruleForm, ...{ list } })
              .then((res) => {
                this.$message.success(`提交成功！`);
                this.backPage();
                done();
                this.loading = false;
              })
              .catch(() => {
                done();
                this.loading = false;
              });
          }
        }
      });
    },
    //返回页面
    backPage() {
      this.$router.$avueRouter.closeTag();
    },
    // 打开备货办单信息
    openDialogInfo() {
      this.dialogShow = true;
      setTimeout(() => {
        this.$refs.getDialogInfo.openDialogInfo({
          list: this.formData.list,
          query: { goodsOwner: this.ruleForm.goodsOwner },
        });
      }, 0);
    },
    //获取关联备货办单信息
    getData(data, type = false) {
      this.orderNo = "";
      this.formData.list = data.map((res, index) => {
        this.orderNo = this.orderNo + res.contractNo + ",";
        if (type) {
          return {
            ...res,
            myId: res.prepareOrderId,
            $cellEdit: true,
          };
        } else {
          let containerTotal = this.isNull(this.ruleForm.containerTotal)
            ? 0
            : this.ruleForm.containerTotal;
          return {
            ...res,
            carriageTotal: this.isNull(res.carriageTotal)
              ? 0
              : res.carriageTotal,
            containerTotal: index == 0 ? containerTotal : 0,
            myId: res.id,
            $cellEdit: true,
          };
        }
      });
      this.dialogShow = false;
      // this.list[0].containerTotal = this.isNull(this.ruleForm.containerTotal) ? 0 : this.ruleForm.containerTotal
    },
    //删除装车明细
    deleteTable({ $index, orderNo }) {
      this.$confirm("确定删除选中信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        console.log(orderNo);
        this.list.splice($index, 1);
        let orderNoList = this.orderNo.split(",");
        orderNoList = orderNoList.filter((res) => res != orderNo);
        this.orderNo = orderNoList.join(",");

        this.$message({
          type: "success",
          message: "删除成功!",
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;

  p {
    margin: 0;
    font-size: 14px;
    font-weight: bold;
  }

  .button {
    display: flex;
    align-items: center;
  }
}

.info {
  padding-top: 10px;

  ::v-deep .avue-form__menu {
    display: none;
  }
}

.order-info-title {
  display: flex;
  align-items: center;
  margin: 10px 0;

  .tip {
    font-size: 12px;
  }

  .input {
    width: 260px;
    margin: 0 14px;
  }
}

::v-deep .cell {
  .el-form-item {
    margin-bottom: 5px !important;
  }

  .el-form-item__content {
    display: flex;
    align-items: center;
  }
}
</style>
